<template>
    <svg width="1419" height="93" viewBox="0 0 1419 93" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0 93V0H1334.5C1334.5 0 1343.96 8.1375 1343.96 10.4625C1343.96 12.7875 1334.5 19.7625 1334.5 19.7625C1334.5 19.7625 1149.92 19.0791 1149.83 19.1812C1149.75 19.2834 1149.83 23.8312 1149.83 23.8312H1409.04C1409.04 23.8312 1419 30.8062 1419 33.1312C1419 35.4562 1409.04 43.0125 1409.04 43.0125H1169.26V47.6625H1369.12C1369.12 47.6625 1379.58 56.3812 1379.58 58.7062C1379.58 61.0312 1369.12 68.0062 1369.12 68.0062H1122.44V72.6562H1283.5C1283.5 72.6562 1293.96 80.7937 1293.96 83.1187C1293.96 85.4437 1283.5 93 1283.5 93H0Z"
            fill="url(#paint0_linear_7780_9176)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_7780_9176"
                x1="60.7558"
                y1="46.2092"
                x2="375.49"
                y2="46.2092"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#E0F7F6" />
                <stop offset="1" stop-color="#EDE5FB" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'TitleBackground',
};
</script>
